const MONTH_NAMES = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sept", "Oct", "Nov", "Dec",
];

export function formatReleaseDate(dateString) {
  if (!dateString) return "";

  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateString);
  if (match) {
    const [, , month, day] = match;
    const monthName = MONTH_NAMES[parseInt(month, 10) - 1] || month;
    const dayNum = parseInt(day, 10);
    return `${dayNum} ${monthName}`;
  }

  return dateString;
}
